import '@/app/app.css';
import './main-en.css';
import '@/app/app';

import { Tabs } from '@/shared/common/tabs/tabs';

window.addEventListener('DOMContentLoaded', () => {
	const historyTabs = document.querySelector('.history-tabs');
	new Tabs(historyTabs);

	const historyYearsContainer = document.querySelectorAll('.history-years');
	historyYearsContainer.forEach((container) => {
		reorderGridItems(container, container.querySelectorAll('.history-year'));
	});
});

function reorderGridItems(container, items) {
	const elements = [...items];
	const rows = Math.ceil(elements.length / 2);

	const reordered = [];

	for (let i = 0; i < rows; i++) {
		if (elements[i]) reordered.push(elements[i]);
		if (elements[i + rows]) reordered.push(elements[i + rows]);
	}

	container.append(...reordered);
}

/* Promo slider */
import { mainPromoSlider } from '@/features/main/main-hero/main-promo-slider/main-promo-slider';
window.addEventListener('DOMContentLoaded', () => {
	mainPromoSlider();
});

/* Featured slider */
import { mainFeaturedSlider } from '@/features/main/main-featured/main-featured';
window.addEventListener('DOMContentLoaded', () => {
	mainFeaturedSlider();
});

/* Service slider */
import {
	mainServiceCardModal,
	mainServiceFlipCards,
	mainServiceSlider,
} from '@/features/main/main-service/main-service';
window.addEventListener('DOMContentLoaded', () => {
	mainServiceSlider();
	mainServiceFlipCards();
	mainServiceCardModal();
});

/* Testimonials collapse */
import { mainTestimonialsCollapse } from '@/features/main/main-testimonials/main-testimonials';
window.addEventListener('DOMContentLoaded', () => {
	mainTestimonialsCollapse();
});

/* History collapse */
import { mainHistoryCollapse } from '@/features/main/main-history/main-history';
window.addEventListener('DOMContentLoaded', () => {
	mainHistoryCollapse();
});

/* Products collapse */
import { mainProductsCollapse } from '@/features/main/main-products/main-products';
window.addEventListener('DOMContentLoaded', () => {
	mainProductsCollapse();
});

/* Marquee */
import { marquee } from '@/shared/common/marquee/marquee';
window.addEventListener('DOMContentLoaded', () => {
	marquee();
});

/* Notice */
import { notice } from '@/shared/notice/notice';
window.addEventListener('DOMContentLoaded', () => {
	notice();
});
